import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CompanyContactInfoBox from '../CompanyContactInfoBox';
import CompanyUsers from '../CompanyUsers';
import { CompanyInfo } from './CompanyInfoCard';
import { CompanyServices } from '../../common/models/user.models';

interface CompanyContactDialogProps {
  isOpen: boolean;
  company: Omit<CompanyInfo, keyof CompanyServices>;
  contractRequestButton?: React.JSX.Element;
  onClose: () => void;
}
export default function CompanyContactDialog({ isOpen, company, contractRequestButton, onClose }: CompanyContactDialogProps): React.JSX.Element {
  const { t } = useTranslation(['common', 'contracts']);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{
        '& .MuiPaper-root.MuiDialog-paper': {
          minWidth: {
            xs: 'calc(100vw - 64px)',
            sm: 600,
            md: 800,
          },
        },
      }}
    >
      <DialogTitle>
        <Typography>{`${t('common:contact')} ${company.tradeName}`}</Typography>
      </DialogTitle>
      <DialogContent>
        <CompanyUsers company={company} />
        <CompanyContactInfoBox company={company} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="text">
          {t('common:close')}
        </Button>
        {contractRequestButton}
      </DialogActions>
    </Dialog>
  );
}
